//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
    state: {
        stcDriverGroup: [],
        searchRequest: null,
      },

      mutations: {
        updateSTCDriverGroup(state, list) {
          state.stcDriverGroup = list;
        },
        updateSearchSTCDriverGroupRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async stcDriverGroup({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))
          console.log("stcdrivergroup request to send: " + requestToSend);
          const st = performance.now();
          //const result = await api.post('/api/w/stc/WebSearchDriverGroup', requestToSend);
          const result = await newAPIPost('/api/w/stc/WebSearchDriverGroup', requestToSend);
          commit('updateSearchSTCDriverGroupRequest', fallbackRequest);
          console.log("driver groups: " + JSON.stringify(result));
          return commit('updateSTCDriverGroup', result);
                },
      },

      getters: {
        getSTCDriverGroup: state => state.stcDriverGroup,
      },
}